module.exports = __webpack_public_path__ + "media/preview/expo@2x-7f975fea.png";